// extracted by mini-css-extract-plugin
export default {"errorBox":"ListErrorBox_errorBox__DZTUM","errorMessage":"ListErrorBox_errorMessage__KW292","errorButton":"ListErrorBox_errorButton__IFcSt"};